import $ from 'jquery';
const gmapsapi = require('google-maps-api')('AIzaSyCm5aHzW3YzN9fR3QensAE1LbT3af8ZkbM');


export default class Map {
  constructor() {
    this.markersBlocks = $('.map__marker');
    this.markers = [];
    this.map = '';

    $.each(this.markersBlocks, (i, el) => {
      const $el = $(el);
      this.markers.push(
        {
          latlng: [$el.data('lat'), $el.data('lng')],
          title: $el.data('title'),
          descr: $el.data('descr'),
        }
      );
    });
  }


  init() {
    gmapsapi().then((maps) => {
      this.map = new maps.Map(document.getElementById('map'), {
        center: new maps.LatLng(this.markers[0].latlng[0], this.markers[0].latlng[1]),
        zoom: 12,
        mapTypeId: 'roadmap',
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: maps.MapTypeControlStyle.DEFAULT,
          position: maps.ControlPosition.TOP_LEFT,
        },
        scrollwheel: false,
        panControl: false,
        zoomControl: true,
        zoomControlOptions: {
          style: maps.ZoomControlStyle.LARGE,
          position: maps.ControlPosition.TOP_LEFT,
        },
        scaleControl: false,
        streetViewControl: false,
      });

      const infoWindow = new maps.InfoWindow();
      this.markers.map(marker => this.createMarker(maps, marker, infoWindow));
    });
  }


  createMarker(maps, m, iw) {
    const latlng = new maps.LatLng(m.latlng[0], m.latlng[1]);
    const marker = new maps.Marker({
      position: latlng,
      map: this.map,
      title: m.title,
      descr: m.descr,
      icon: '/assets/img/map-marker.png',
    });

    maps.event.addListener(marker, 'click', () => {
      this.map.setCenter(marker.position);
      iw.setContent(`
        <div class='map__markerInfo'>
          <div class='map__markerInfoTitle'>${marker.title}</div>
          <div class='map__markerInfoDescr'>${marker.descr}</div>
        </div>
      `);
      iw.open(this.map, marker);
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/blocks/map/map.js
 **/